module.exports = __webpack_public_path__ + "img/ayan-nag-midnight-gleam.d6f3643.jpg";